import { render } from "./ItemTable2.vue?vue&type=template&id=23080100"
import script from "./ItemTable2.vue?vue&type=script&lang=js"
export * from "./ItemTable2.vue?vue&type=script&lang=js"

import "./ItemTable2.vue?vue&type=style&index=0&id=23080100&lang=css"

import exportComponent from "/builds/furore-dev/front-fincas-agrogo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__